import { ContextMenuMESFProvider } from "../../../controls/contextMenu/useContextMenuMESF";
import { LMFProcessesPage } from "./LMFProcessesPage";
import { LMFProcessesProvider } from "./context/LMFProcessesContext";

type Props = {};
const LMFProcesses = (props: Props) => {
  return (
    <ContextMenuMESFProvider>
      <LMFProcessesProvider>
        <LMFProcessesPage />
      </LMFProcessesProvider>
    </ContextMenuMESFProvider>
  );
};
export default LMFProcesses;
